import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/interfaces/stores/RootState';
import { Enrollment } from '@/interfaces/models/Enrollment';
import AuthApiService from '@/api/http/AuthApiService';
import Filter from '@/interfaces/api/Filter';
import { Pagination } from '@/interfaces/api/Pagination';
import { Page } from '@/interfaces/api/Page';
import { AxiosResponse } from 'axios';

interface EnrollmentsState {
  items: Enrollment[];
  filter: Filter;
  pagination: {
    total: number;
  };
}

const api: AuthApiService = new AuthApiService();

const state: EnrollmentsState = {
  items: [],
  filter: {},
  pagination: {
    total: 10,
  },
};

const actions: ActionTree<EnrollmentsState, RootState> = {
  fetch({ commit, state }, data: { page: Page }) {
    return api
      .getEnrollments(data.page, state.filter)
      .then((res: AxiosResponse<Enrollment[] | Pagination<Enrollment>>) => {
        commit('setItems', res.data);
      });
  },
  setFilter({ commit }, filter: Filter) {
    commit('setFilter', filter);
  },
};

const mutations: MutationTree<EnrollmentsState> = {
  setItems(state: EnrollmentsState, data: Pagination<Enrollment>) {
    state.items = (data.data as Enrollment[]) || data;

    if (data.total) {
      state.pagination.total = data.total;
    }
  },
  setFilter(state: EnrollmentsState, data: Filter) {
    state.filter = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
